<template>
  <svg width="24"
       height="30"
       viewBox="0 0 56 73"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M39.7014 0H1.9053C0.853023 0 0 0.853023 0 2.50828V71.6279C0 72.0772 0.853023 72.9302 1.9053 72.9302H54.0947C55.147 72.9302 56 72.0772 56 71.6279V16.9016C56 15.9952 55.8789 15.7034 55.6653 15.4886L40.5114 0.334698C40.2966 0.121116 40.0048 0 39.7014 0Z"
          fill="#E9E9E0"/>
    <path d="M40.3716 0.196289V15.6275H55.8028L40.3716 0.196289Z"
          fill="#D9D7CA"/>
    <path d="M54.0947 72.9291H1.9053C0.853023 72.9291 0 72.0761 0 71.0238V50.7896H56V71.0238C56 72.0761 55.147 72.9291 54.0947 72.9291Z"
          fill="#007D87"/>
    <path d="M17.3403 23.4997C20.4731 23.4997 23.0127 20.9601 23.0127 17.8274C23.0127 14.6946 20.4731 12.155 17.3403 12.155C14.2076 12.155 11.668 14.6946 11.668 17.8274C11.668 20.9601 14.2076 23.4997 17.3403 23.4997Z"
          fill="url(#paint0_linear_35598_1871)"/>
    <path d="M4.8623 46.1894L5.37773 45.4579L14.5408 32.243C15.0562 31.4879 15.8808 31.0513 16.7742 31.0513C17.6676 31.0513 18.4923 31.4879 19.0077 32.2312L22.5011 37.2694L32.0078 24.5973C32.5347 23.9012 33.3364 23.5 34.184 23.5C35.0316 23.5 35.8448 23.9012 36.3602 24.5973L51.9374 45.3635L52.5101 46.1304"
          fill="#00CC99"/>
    <path d="M19.104 65.0662C19.104 65.7168 19.0293 66.2688 18.88 66.7222C18.736 67.1702 18.4773 67.5115 18.104 67.7462C17.7307 67.9755 17.1973 68.0902 16.504 68.0902C16.1093 68.0902 15.728 68.0475 15.36 67.9622C14.992 67.8768 14.7387 67.8102 14.6 67.7622L14.688 66.1462C14.8533 66.1995 15.04 66.2662 15.248 66.3462C15.4613 66.4208 15.72 66.4582 16.024 66.4582C16.5467 66.4582 16.904 66.3142 17.096 66.0262C17.288 65.7382 17.384 65.2608 17.384 64.5942V56.3622H19.104V65.0662ZM21.7296 67.9302V56.3622H25.7376C26.5643 56.3622 27.303 56.5035 27.9536 56.7862C28.6096 57.0688 29.1243 57.4848 29.4976 58.0342C29.8763 58.5835 30.0656 59.2582 30.0656 60.0582C30.0656 60.8262 29.8923 61.4822 29.5456 62.0262C29.2043 62.5648 28.7243 62.9782 28.1056 63.2662C27.4923 63.5488 26.7803 63.6902 25.9696 63.6902H23.4736V67.9302H21.7296ZM23.4656 62.2902H25.9216C26.6576 62.2902 27.2576 62.0795 27.7216 61.6582C28.1856 61.2315 28.4176 60.6662 28.4176 59.9622C28.4176 59.2475 28.1776 58.7008 27.6976 58.3222C27.2176 57.9382 26.6043 57.7462 25.8576 57.7462H23.4656V62.2902ZM36.3945 68.0902C35.3652 68.0902 34.4772 67.8555 33.7305 67.3862C32.9838 66.9168 32.4078 66.2422 32.0025 65.3622C31.6025 64.4768 31.4025 63.4155 31.4025 62.1782C31.4025 60.9302 31.6078 59.8608 32.0185 58.9702C32.4345 58.0742 33.0238 57.3888 33.7865 56.9142C34.5492 56.4395 35.4452 56.2022 36.4745 56.2022C37.0878 56.2022 37.6558 56.3062 38.1785 56.5142C38.7065 56.7222 39.1705 57.0048 39.5705 57.3622C39.9758 57.7195 40.2958 58.1248 40.5305 58.5782C40.7652 59.0315 40.8985 59.5062 40.9305 60.0022H39.1065C39.0318 59.5915 38.8718 59.2128 38.6265 58.8662C38.3865 58.5142 38.0798 58.2315 37.7065 58.0182C37.3332 57.8048 36.9118 57.6982 36.4425 57.6982C35.8185 57.6982 35.2665 57.8528 34.7865 58.1622C34.3065 58.4715 33.9305 58.9542 33.6585 59.6102C33.3918 60.2608 33.2585 61.1035 33.2585 62.1382C33.2585 62.9435 33.3412 63.6288 33.5065 64.1942C33.6772 64.7595 33.9092 65.2155 34.2025 65.5622C34.4958 65.9088 34.8398 66.1622 35.2345 66.3222C35.6292 66.4768 36.0505 66.5542 36.4985 66.5542C36.9412 66.5542 37.3305 66.4768 37.6665 66.3222C38.0025 66.1675 38.2825 65.9675 38.5065 65.7222C38.7358 65.4768 38.9118 65.2128 39.0345 64.9302C39.1625 64.6422 39.2372 64.3648 39.2585 64.0982L39.3145 63.1622H36.6105V61.9302L41.0985 61.9462V67.9302H39.8585V66.2342C39.6558 66.5488 39.4025 66.8475 39.0985 67.1302C38.7945 67.4128 38.4212 67.6448 37.9785 67.8262C37.5358 68.0022 37.0078 68.0902 36.3945 68.0902Z"
          fill="white"/>
    <defs>
      <linearGradient id="paint0_linear_35598_1871"
                      x1="13.1477"
                      y1="21.8683"
                      x2="15.3819"
                      y2="12.0764"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#A58500"/>
        <stop offset="0.5028"
              stop-color="#FBC402"/>
        <stop offset="1"
              stop-color="#FFE9A4"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'JPGIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 18
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
